export let version = "v2.5.140.258";



// WEBPACK FOOTER //
// ./src/providers/version.ts